import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AboutComponent } from './about.component';
import { TeamComponent } from './team/team.component';
import { ApdiffComponent } from './apdiff/apdiff.component';
import { ContactComponent } from './contact/contact.component';
// import { NewsComponent } from './news/news.component';

import { routes } from './about.router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    routes
  ],
  declarations: [
    AboutComponent,
    TeamComponent,
    ApdiffComponent,
    ContactComponent
    // NewsComponent
  ]
})
export class AboutModule { }
